import { watchForAllRequestSagas } from './RequestSagas/sagas';
import { all } from 'redux-saga/effects';
import { watchApplicationAsyncSagas } from './ApplicationAsyncSagas/sagas';
import { watchForAllSurveySagas } from './surveyRedirectSaga';
import { watchForAllAppointmentSagas } from './Appointments/sagas';
import { watchForAllPatientInfoSagas } from './PatientInfo/sagas';

export default function* rootSaga() {
    yield all([
        watchForAllAppointmentSagas(),
        watchForAllSurveySagas(),
        watchApplicationAsyncSagas(),
        watchForAllRequestSagas(),
        watchForAllPatientInfoSagas()
    ])
}




// WEBPACK FOOTER //
// ./src/sagas/index.ts